import { render, staticRenderFns } from "./ApfLanguageSection.vue?vue&type=template&id=078255c0&scoped=true"
import script from "./ApfLanguageSection.vue?vue&type=script&lang=js"
export * from "./ApfLanguageSection.vue?vue&type=script&lang=js"
import style0 from "./ApfLanguageSection.vue?vue&type=style&index=0&id=078255c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078255c0",
  null
  
)

export default component.exports